module.exports = __webpack_public_path__ + "static/media/phone.1c77d4cc.svg";